import React from "react";
//import PropTypes from "prop-types";
import Card from "./Card"

class CardSlot extends React.Component {

    place = (e) => {
        if (![...e.currentTarget.classList].includes("can-place")) return;
        this.props.placeCard(e.currentTarget);
    };

    moveHere = () => {
        this.props.moveCard(this.props.id)
    }

    render() {
        if(!this.props.id || !this.props.cards) return null;
        const card = this.props.cards[this.props.id];
        let selected = "";
        if (this.props.selectedCard === card) {selected="selected"}
        let canPlace = this.props.canPlace;
        if (!canPlace && !card) {canPlace = ""};
        if (!card) {
            if (canPlace) return (
                <div onClick={this.place} className={`card-slot ${canPlace}`} id={this.props.id}>Card</div>
            );
            if (this.props.canMoveHere) return (
                <div onClick={this.moveHere} className={`card-slot ${canPlace} ${this.props.canMoveHere}`} id={this.props.id}>Card</div>
            );
            return (
                <div className={`card-slot`} id={this.props.id}>Card</div>
        )};
        return (
            <div className={`card-slot ${selected}`} id={this.props.id}>
                <Card 
                card={card}
                team={card.type}
                showMoves={this.props.showMoves}
                id={this.props.id}
                type={"boardCard"}
                openCityShop={this.props.openCityShop}
                game={this.props.game}
                />
            </div>
        );
    };
};

export default CardSlot;